module.exports = __webpack_public_path__ + "static/media/icon_settings_globe.e66aac3d.svg";